import { useLocation } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import TrustBannerSection from "@/components/feature/TrustBannerSection";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4">
      <SEOHead
        title="Página no encontrada | Persianas Málaga"
        description="La página que buscas no existe. Reparación de persianas y mosquiteras en Málaga capital. Contacta con nosotros para tu presupuesto gratis."
        noindex
      />
      <div className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </div>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">Página no encontrada</h1>
        <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">
          La página que buscas no existe. <a href="/" className="text-primary-500 hover:text-primary-600 underline">Volver al inicio</a>
        </p>
      </div>
      <div className="w-full mt-auto">
        <TrustBannerSection />
        <Footer />
      </div>
      <WhatsAppFloat />
    </div>
  );
}